import { CommonModule } from '@angular/common';
import { FilterByKeyPipe } from './filter-by-key.pipe';
import { GetIndexPipe } from './get-index.pipe';
import { FilterPipe } from './filter.pipe';
import { NgModule } from '@angular/core';
import { OrderPipe } from './order-by.pipe';
import { SafeUrlPipe } from './safe-url.pipe';
import { TruncatePipe } from './truncate.pipe';
import { DateFormatPipe } from './date-format.pipe';
import { ValueByFieldPipe } from './value-by-field.pipe';
import { ExistItemInListPipe } from './exist-item-in-list.pipe';
import { IsOldTimePipe } from './is-old-time.pipe';
import { TimeToAmPmPipe } from './time-to-am-pm.pipe';
import { DateUtcToLocalPipe } from './date-utc-to-local.pipe';
import { CountItemsByPositiveFlag } from './count-items-by-positive-flag.pipe';
import { SearchPipe } from './search.pipe';
import { GetObjectByKeyFromArrayPipe } from './get-object-by-key-from-array.pipe';
import { WidgetInPrintableModePipe } from './widget-in-printable-mode.pipe';
import { RmTagsPipe } from './rm-tags.pipe';
import { FileAcceptFormatPipe } from './file-accept-format.pipe';
import { StringToJson } from './stringToJson.pipe';
import { NewLineReplacerPipe } from './new-liner-replacer.pipe';
import { StringReplacerPipe } from './string-replacer.pipe';
import { IsSelectedPipe } from './isSelected.pipe';
import { FilterByCallbackPipe } from './filter-by-callback.pipe';
import { TimeByMinutesPipe } from './time-by-minutes.pipe';
import { IsEventInTimeRangePipe } from './is-event-in-time-range.pipe';
import { GetTimeInMinutesPipe } from './get-time-in-minutes.pipe';
import { SimpleDateFormatPipe } from './simple-date-format.pipe';
import { GetColumnWidthPipe } from './get-column-width.pipe';
import { MakeColorDarkerPipe } from './make-color-darker.pipe';
import { MinutesToHoursPipe } from './minutes-to-hours.pipe';
import { GetWordsPipe } from './get-words.pipe';
import { WithLoadingPipe } from './with-loading.pipe';
import { SplitNamePipe } from './split-name.pipe';
import { FormStatusColorPipe } from './form-status-color.pipe';
import { GetFormInitialsPipe } from './get-form-initials.pipe';
import { NumberFilterPipe } from './number-filter/number-filter.pipe';
import { DateHasNullPipe } from './date-has-null.pipe';
import { FromFullNamePipe } from './from-fullname.pipe';
import { GetCategoryItemsPipe } from './get-category-items.pipe';

@NgModule({
  imports: [
    CommonModule,
    OrderPipe,
    FilterPipe,
    TruncatePipe,
    SafeUrlPipe,
    DateFormatPipe,
    ValueByFieldPipe,
    ExistItemInListPipe,
    DateUtcToLocalPipe,
    IsOldTimePipe,
    TimeToAmPmPipe,
    GetWordsPipe,
    CountItemsByPositiveFlag,
    GetObjectByKeyFromArrayPipe,
    WidgetInPrintableModePipe,
    RmTagsPipe,
    SearchPipe,
    FileAcceptFormatPipe,
    StringToJson,
    NewLineReplacerPipe,
    StringReplacerPipe,
    IsSelectedPipe,
    FilterByCallbackPipe,
    TimeByMinutesPipe,
    IsEventInTimeRangePipe,
    GetTimeInMinutesPipe,
    SimpleDateFormatPipe,
    GetColumnWidthPipe,
    MakeColorDarkerPipe,
    MinutesToHoursPipe,
    WithLoadingPipe,
    GetIndexPipe,
    FilterByKeyPipe,
    SplitNamePipe,
    FormStatusColorPipe,
    GetFormInitialsPipe,
    NumberFilterPipe,
    DateHasNullPipe,
    FromFullNamePipe,
    GetCategoryItemsPipe,
  ],
  exports: [
    OrderPipe,
    FilterPipe,
    TruncatePipe,
    SafeUrlPipe,
    DateFormatPipe,
    ValueByFieldPipe,
    ExistItemInListPipe,
    DateUtcToLocalPipe,
    IsOldTimePipe,
    TimeToAmPmPipe,
    GetWordsPipe,
    CountItemsByPositiveFlag,
    GetObjectByKeyFromArrayPipe,
    WidgetInPrintableModePipe,
    RmTagsPipe,
    SearchPipe,
    FileAcceptFormatPipe,
    StringToJson,
    NewLineReplacerPipe,
    StringReplacerPipe,
    IsSelectedPipe,
    FilterByCallbackPipe,
    TimeByMinutesPipe,
    IsEventInTimeRangePipe,
    GetTimeInMinutesPipe,
    SimpleDateFormatPipe,
    GetColumnWidthPipe,
    MakeColorDarkerPipe,
    MinutesToHoursPipe,
    WithLoadingPipe,
    GetIndexPipe,
    FilterByKeyPipe,
    SplitNamePipe,
    FormStatusColorPipe,
    GetFormInitialsPipe,
    NumberFilterPipe,
    DateHasNullPipe,
    FromFullNamePipe,
    GetCategoryItemsPipe,
  ],
  providers: [
    OrderPipe,
    FilterPipe,
    TruncatePipe,
    SafeUrlPipe,
    DateFormatPipe,
    ValueByFieldPipe,
    ExistItemInListPipe,
    DateUtcToLocalPipe,
    IsOldTimePipe,
    TimeToAmPmPipe,
    GetWordsPipe,
    CountItemsByPositiveFlag,
    GetObjectByKeyFromArrayPipe,
    WidgetInPrintableModePipe,
    RmTagsPipe,
    SearchPipe,
    FileAcceptFormatPipe,
    StringToJson,
    NewLineReplacerPipe,
    StringReplacerPipe,
    IsSelectedPipe,
    FilterByCallbackPipe,
    TimeByMinutesPipe,
    IsEventInTimeRangePipe,
    GetTimeInMinutesPipe,
    SimpleDateFormatPipe,
    MinutesToHoursPipe,
    GetColumnWidthPipe,
    MakeColorDarkerPipe,
    GetIndexPipe,
    FilterByKeyPipe,
    SplitNamePipe,
    FormStatusColorPipe,
    NumberFilterPipe,
    GetFormInitialsPipe,
    DateHasNullPipe,
    FromFullNamePipe,
  ],
})
export class RxPipesModule {}
